import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {SearchService} from '../../../sdk/component/search/search.service';
import {SearchForm} from '../../../sdk/component/search/searchForm';
import {Role, User, UsersSortField, WebUserService} from 'web-angular-client';
import {AuthenticationService} from '../../../sdk/service/authentication.service';
import {AlertService} from '../../../sdk/service/alert.service';
import {EnvironmentService} from '../../../sdk/service/environment.service';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss'],
    providers: [WebUserService],
    standalone: false
})
export class UserListComponent extends SearchForm
{
    private userRole: Role.NameEnum;

    constructor(
        protected router: Router,
        protected authenticationService: AuthenticationService,
        protected environmentService: EnvironmentService,
        protected searchService: SearchService,
        protected userService: WebUserService,
        protected alertService: AlertService)
    {
        super(authenticationService, userService, searchService, environmentService);
    }

    get userList(): User[]
    {
        return this.results?.content;
    }

    ngOnInit(): void
    {
        super.ngOnInit();

        this.userRole = this.authenticationService.getUserRole();
    }

    create()
    {
        // not used but required to be implemented
    }

    view(user: User)
    {
        // not used but required to be implemented
    }

    getDefaultSortField(): string
    {
        return UsersSortField.ID;
    }

    edit(user: User)
    {
        if (this.isGuestAdminUser())
        {
            this.alertService.error('Guest accounts cannot perform this action.', false);
            return;
        }

        this.router.navigate([this.routes.SECURE.USER.EDIT.pathSansParameters, user.id]).then();
    }

    canEditUser(user: User): boolean
    {
        if (this.userRole === Role.NameEnum.SUPER_ADMIN)
        {
            return true;
        }

        if (this.userRole === Role.NameEnum.ADMIN)
        {
            return user.role.name === Role.NameEnum.ADMIN || user.role.name === Role.NameEnum.FIELD_AGENT;
        }

        return false;  // Return false for roles other than SUPER_ADMIN and ADMIN
    }

    getEditTooltipMessage(): string
    {
        if (this.isGuestAdminUser())
        {
            return 'Guest accounts cannot edit users.';
        }
        else
        {
            return `Administrators can only edit users at their current role level or below.`;
        }
    }
}